//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const gauntlets = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 3, 3, 3, 3, 0, 0, 3, 3, 3, 3, 0, 
    0, 2, 2, 4, 2, 0, 0, 2, 2, 4, 2, 0, 
    0, 4, 1, 1, 2, 0, 0, 4, 1, 1, 2, 0, 
    0, 2, 1, 1, 4, 0, 0, 2, 1, 1, 4, 0, 
    5, 2, 4, 2, 2, 0, 0, 2, 4, 2, 2, 5, 
    5, 2, 2, 2, 2, 0, 0, 2, 2, 2, 2, 5, 
    0, 3, 3, 3, 3, 0, 0, 3, 3, 3, 3, 0, 
    0, 5, 5, 5, 5, 0, 0, 5, 5, 5, 5, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]